import { GameId } from '../game-settings';

export enum StatType {
  health = 'health',
  armorElectrical = 'armorElectrical',
  armorMechanical = 'armorMechanical',
  powerElectrical = 'powerElectrical',
  powerMechanical = 'powerMechanical',
  speedMove = 'speedMove'
}

// Stat types that may not be specified in the configuration.
export enum OptionalStatType {
  raw = 'raw',
  scaleSpeedAttack = 'scaleSpeedAttack',
  scaleCastRange = 'scaleCastRange',
  scaleDamageIntakeAll = 'scaleDamageIntakeAll',
  scaleDamageIntakeRole = 'scaleDamageIntakeRole' // for debuffs that scales damage intake only for role skills, not part skills.
}

export type AnyStatType = StatType | OptionalStatType;

export enum StatTypeTf {
  sandSpeedScalar = 'sandSpeedScalar',
  rockSpeedScalar = 'rockSpeedScalar'
}

export const terraformingStatToTerrain: Record<StatTypeTf, string> = {
  [StatTypeTf.sandSpeedScalar]: 'sand',
  [StatTypeTf.rockSpeedScalar]: 'rock'
};

export interface IBotStats {
  [GameId.ActionGame]: Record<StatType, number>;
  [GameId.Terraforming]: Record<StatTypeTf, number>;
}
